var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default (_a) => {
    var { size, className, fill } = _a, rest = __rest(_a, ["size", "className", "fill"]);
    return (_jsxs("svg", Object.assign({ xmlnsXlink: "http://www.w3.org/1999/xlink", width: size, height: size, viewBox: "0 0 40 40", className: className, fill: fill }, rest, { children: [_jsx("path", { d: "M33.71,14.69H19.43V10A8.56,8.56,0,0,0,2.31,10v5a1,1,0,0,0,2,0V10a6.57,6.57,0,0,1,13.14,0v4.7a4,4,0,0,0-3.59,3.93V34.55a4,4,0,0,0,4,4H33.71a4,4,0,0,0,4-4V18.66A4,4,0,0,0,33.71,14.69Zm2,19.86a2,2,0,0,1-2,2H17.82a2,2,0,0,1-2-2V18.66a2,2,0,0,1,2-2H33.71a2,2,0,0,1,2,2Z" }, void 0), _jsx("path", { d: "M25.78,22.29a3.35,3.35,0,0,0-1.13,6.5v4.34h2.26V28.79a3.35,3.35,0,0,0-1.13-6.5Z" }, void 0)] }), void 0));
};
